import React from 'react';

import { Skeleton } from '@crehana/ui';

interface CardSkeletonPorps {
  className?: string;
  dark?: boolean;
}

export const CourseCardSkeleton = ({ className, dark }: CardSkeletonPorps) => (
  <div className={className}>
    <Skeleton isDark={dark} className="h-160 rounded-t-5" />
    <div className="p-16">
      <Skeleton isDark={dark} className="h-16 mb-2" />
      <Skeleton isDark={dark} className="h-16 mb-12 w-1/3" />

      <div className="min-h-40 mb-8">
        <Skeleton isDark={dark} className="h-16 w-1/2" />
      </div>

      <Skeleton isDark={dark} className="h-20 w-1/3" />

      <Skeleton isDark={dark} className="h-48 mt-16 rounded-5" />
    </div>
  </div>
);
